<template>
  <router-view></router-view>
</template>


<script>
import {OVERRIDE_LAYOUT_CONFIG} from "@/core/store/modules/layout/constants";
import {BANNED_ACCOUNT} from "@/core/store/modules/errors/constants";

export default {
  name: "App",
  mounted() {
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
    this.$store.dispatch(BANNED_ACCOUNT);
  }
};
</script>


<style lang="scss">
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";
@import "assets/css/style.vue.rtl";
@import "assets/css/style.css";
@import "assets/scss/custom.scss";

</style>